export class AppSettings {
	amchartsKey?: string = "CH200326614568128";
}
